//보상 목록 ip별 html 태그
import reward_list from './reward_list';

//부모 요소
const item = document.querySelector('.p-layer-service');
const item_reward = document.querySelector('.p-layer--reward__item');

//선택 시 콜백 함수
const select = target => ele => {
    if(ele == target) {
        ele.classList.remove('p-layer-service__item--disabled');
    }else{
        ele.classList.add('p-layer-service__item--disabled');
        ele.classList.remove('p-layer-service__item--active');
    }
}

//해제 시 콜백 함수
const unSelect = ele => {
    ele.classList.remove('p-layer-service__item--disabled');
}

//클릭 버블링 이벤트
export default item.addEventListener('click',function(event){
    let old_class = document.querySelector('.p-layer-service__item--active').dataset.ip;
    let new_class = event.target.dataset.ip;

    //부모 요소들 클릭 한 경우 이벤트 중단.
    if(event.target.querySelector('.p-layer-service__item') || (old_class == new_class)) return false;

    item_reward.classList.add('p-layer--reward__item--'+new_class);
    item_reward.classList.remove('p-layer--reward__item--'+old_class);

    item_reward.innerHTML = reward_list[new_class];

    if(event.target.classList.toggle('p-layer-service__item--active')){
        Array.prototype.map.call(this.querySelectorAll('.p-layer-service__item'), select(event.target));
    }else{
        Array.prototype.map.call(this.querySelectorAll('.p-layer-service__item'), unSelect);
    }
});



// WEBPACK FOOTER //
// ./src/js/func/select_service_reward.js